module.exports = __webpack_public_path__ + "static/tint-1-e0141a025f2371314dc9dc36ae3e1fd8.jpg";